// Retour après login + `state` du login Google (PLAN_CONNECTEUR_MCP.md, lot 1a), gardés en sessionStorage (par onglet :
// la redirection Google revient dans le même onglet).

const RETURN_KEY = "post_login_redirect";
const GOOGLE_STATE_KEY = "google_oauth_state";
// Seule destination acceptée : la page de consentement du connecteur Claude — jamais une URL libre (redirection ouverte).
const RETURN_RE = /^\/oauth\/consent\?req=[A-Za-z0-9_-]{16,64}$/;   // même format que CONSENT_REQ_RE (back : ≤ 64)

/** Retient où revenir après le login ; ignoré si ce n'est pas une page de consentement. */
export function setPostLoginRedirect(path) {
  if (!RETURN_RE.test(path || "")) return;
  try { sessionStorage.setItem(RETURN_KEY, path); } catch { /* stockage bloqué : retour à l'accueil */ }
}

/** Destination après un login réussi (lue une seule fois) ; « / » par défaut. */
export function takePostLoginRedirect() {
  let path = null;
  try {
    path = sessionStorage.getItem(RETURN_KEY);
    sessionStorage.removeItem(RETURN_KEY);
  } catch { /* stockage bloqué */ }
  return RETURN_RE.test(path || "") ? path : "/";
}

/** Nouveau `state` anti-CSRF pour l'URL Google (32 hex), gardé pour la vérification au retour. */
export function newGoogleState() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  const state = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  try { sessionStorage.setItem(GOOGLE_STATE_KEY, state); } catch { /* le retour sera refusé */ }
  return state;
}

/** Vrai seulement si `state` est celui émis par CET onglet ; consommé dans tous les cas (usage unique). */
export function checkGoogleState(state) {
  let expected = null;
  try {
    expected = sessionStorage.getItem(GOOGLE_STATE_KEY);
    sessionStorage.removeItem(GOOGLE_STATE_KEY);
  } catch { /* stockage bloqué : refus */ }
  return !!expected && state === expected;
}
